import { IEquipmentLogBookItem } from 'features/inventory/equipments/types';
import { axiosPrivate } from 'shared/api';
import { BaseService } from 'shared/services/BaseService';

export class EquipmentLogBookService extends BaseService<IEquipmentLogBookItem> {
  constructor() {
    super('equipment-logbook');
  }

  /**
   * Fetches the flat chronological logbook stream for a specific piece of laboratory equipment.
   * Leverages the optimized LimitOffset pagination schema.
   *
   * @param equipmentId The database primary key integer ID of the target equipment.
   * @param limit The amount of row items to capture in this current window slice view.
   * @param offset The layout target list index indicator to shift database boundaries.
   * @param extraParams Optional key-value filter parameters (e.g. { event_type: 'Checklist' })
   */
  public async getLogBook(
    equipmentId: number,
    limit = 10,
    offset = 0,
    extraParams: Record<string, unknown> = {}
  ) {
    const response = await axiosPrivate.get(`${this.modulePrefix}/${equipmentId}/`, {
      params: {
        limit,
        offset,
        ...extraParams
      }
    });

    return response.data;
  }
}

export const equipmentLogBookService = new EquipmentLogBookService();
